import { render, staticRenderFns } from "./SettingsOverflow.vue?vue&type=template&id=7bb10365&"
import script from "./SettingsOverflow.vue?vue&type=script&lang=js&"
export * from "./SettingsOverflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports